import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { fetchRemittanceInstructions } from '../api/remittance-instructions.ts';
import { RemittanceInstruction } from '../models/remittance-instruction.ts';

export function useRemittanceInstructions(): UseQueryResult<
  RemittanceInstruction[],
  Error
> {
  const queryFn = fetchRemittanceInstructions;
  return useQuery({
    queryKey: ['remittanceInstructions'],
    queryFn,
  });
}
